export const bdcMealPlanCodes = [
  { code: 0, label: 'None' },
  { code: 1, label: 'All inclusive' },
  { code: 19, label: 'Breakfast' },
  { code: 21, label: 'Lunch' },
  { code: 22, label: 'Dinner' },
  { code: 2, label: 'American' },
  { code: 3, label: 'Bed & breakfast' },
  { code: 4, label: 'Buffet breakfast' },
  { code: 5, label: 'Caribbean breakfast' },
  { code: 6, label: 'Continental breakfast' },
  { code: 7, label: 'English breakfast' },
  { code: 8, label: 'European plan' },
  { code: 9, label: 'Family plan' },
  { code: 10, label: 'Full board' },
  { code: 11, label: 'Full breakfast' },
  { code: 12, label: 'Half board / modified American plan' },
  { code: 14, label: 'Room only' },
  { code: 15, label: 'Self catering' },
  { code: 16, label: 'Bermuda' },
  { code: 17, label: 'Dinner bed and breakfast plan' },
  { code: 18, label: 'Family American' },
  { code: 20, label: 'Modified' },
  { code: 23, label: 'Breakfast & lunch' },
  { code: 24, label: 'Lunch & Dinner' },
]
